$(function () {

  // ページ内リンク
  $('a[href^="#"]').on('click', function () {
    var headerHeight = $('.site-header-main').outerHeight();
    if (!$(this).hasClass('no-scroll')) {
      var href = $(this).attr('href');
      var $target = $(href === '#' || href === '' ? 'html' : href);
      $target.velocity('scroll', {
        duration: 500,
        easing: 'easeInOutQuad',
        offset: -(headerHeight)
      });
      return false;
    }
  });

  // よくある質問アコーディオン
  $('.p-faq > .c-question').on('click', function () {
    $(this).toggleClass('is-open');
  });

});
